import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from '@paypalcorp/pp-react';
import ControlPanel from '@MerchantConfigurator/components/messaging/ControlPanel';
import { PreviewSection } from '@MerchantConfigurator/components/messaging/Preview';
import {
  ConfigsUpdatedCounter,
  ConfigValues,
  Countries,
  defaultConfig,
  elementIDs,
  EventCounters,
  MessagingPlacements
} from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import {
  filterConfigByPlacements,
  getInitialCounters,
  replaceLegacyConfig
} from '@MerchantConfigurator/utils/messaging';

const EligibleView = () => {
  const {
    config,
    defaultConfigsForSupportedPlacements,
    localeConfig,
    onUpdate,
    placements,
    previewEnbaledPlacements,
    showPartnerExperience
  } = useContext(ApplicationContext);

  const santizedMerchantConfig = filterConfigByPlacements({
    config,
    placements
  });

  const { placementsWithLegacyConfig, updatedConfig } = replaceLegacyConfig({
    santizedMerchantConfig
  });

  const initialConfig = {
    ...defaultConfigsForSupportedPlacements,
    ...updatedConfig
  };

  // We need to make sure that non US merchants do not get whiteNoBorder as a possible config
  // The banner style is not currently supported by upstream messaging (Oct, 2023)
  if (localeConfig.countryCode !== Countries.US) {
    if (initialConfig?.home?.color === ConfigValues.color.whiteNoBorder) {
      initialConfig.home.color = ConfigValues.color.white;
    }

    if (initialConfig?.homepage?.color === ConfigValues.color.whiteNoBorder) {
      initialConfig.homepage.color = ConfigValues.color.white;
    }

    if (initialConfig?.category?.color === ConfigValues.color.whiteNoBorder) {
      initialConfig.category.color = ConfigValues.color.white;
    }

    if (initialConfig?.shop?.color === ConfigValues.color.whiteNoBorder) {
      initialConfig.shop.color = ConfigValues.color.white;
    }
  }

  const initialCounters = getInitialCounters({
    placements: previewEnbaledPlacements
  });

  const [activePlacementIndex, setActivePlacementIndex] = useState(0);
  const [counters, setCounters] = useState(initialCounters);
  const [messagingConfig, setMessagingConfig] = useState(initialConfig);

  const updateCounters = (counterName) => {
    const updatedCounter = { ...counters };

    updatedCounter[counterName] = counters[counterName] + 1;

    if (counterName.includes(ConfigsUpdatedCounter)) {
      updatedCounter[EventCounters.totalConfigsUpdated] =
        counters[EventCounters.totalConfigsUpdated] + 1;
    }
    setCounters(updatedCounter);
  };

  const resetConfig = () => {
    let customPlacementDefaultConfig = {};
    //For Custom placement status is the only default config
    if (messagingConfig.custom_placement) {
      customPlacementDefaultConfig[MessagingPlacements.custom_placement] =
        messagingConfig.custom_placement.map((config) => ({
          ...config,
          status: defaultConfig[MessagingPlacements.custom_placement].status
        }));
    }
    setMessagingConfig({
      ...defaultConfigsForSupportedPlacements,
      ...customPlacementDefaultConfig
    });
    updateCounters(EventCounters.resetCustomizationsClicked);

    onUpdate({
      ...defaultConfigsForSupportedPlacements,
      ...customPlacementDefaultConfig
    });
  };

  return (
    <Row id={elementIDs.controlPanelAndPreviewChildContainer}>
      <Col xs={12} xl={5} xxl={5}>
        <ControlPanel
          activePlacementIndex={activePlacementIndex}
          messagingConfig={messagingConfig}
          resetConfig={resetConfig}
          setActivePlacementIndex={setActivePlacementIndex}
          updateCounters={updateCounters}
          setMessagingConfig={setMessagingConfig}
          showPartnerExperience={showPartnerExperience}
        />
      </Col>
      <Col xs={12} xl={7} xxl={7}>
        <PreviewSection
          activePlacementIndex={activePlacementIndex}
          config={messagingConfig}
          setActivePlacementIndex={setActivePlacementIndex}
          updateCounters={updateCounters}
        />
      </Col>
    </Row>
  );
};

export default EligibleView;
